import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Document } from '../../../../shared/sdk';
import * as moment from 'moment';
import Decimal from 'decimal.js';

@Component({
  selector: 'app-payment-qr',
  templateUrl: './payment-qr.component.html',
  styleUrls: ['./payment-qr.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentQrComponent implements OnInit {
  @Input() addClass: string;
  @Input() document: Document;
  @Input() locale: string;
  @Input() show: boolean;

  qr: string;

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    if (!this.document) {
      return;
    }

    const clientName = this.document._documentClient.name.trim().substr(0, 33);
    const clientAddress = (this.document._documentClient.address ? this.document._documentClient.address : '').trim().substr(0, 33);

    let clientCity = '';
    clientCity += this.document._documentClient.ZIP ? this.document._documentClient.ZIP : '';
    clientCity += ' ' + (this.document._documentClient.city ? this.document._documentClient.city : '');
    clientCity = clientCity.trim().substr(0, 33);

    const purposeCode = 'OTHR';
    const typeName = this.toUpperCaseFirst(this.translate.instant(`document.type-name.${this.document.type}`));
    const purpose = (`${typeName} ${this.document.number ? this.document.number : ''}`).trim().substr(0, 42);

    let dateDue = '';

    if (this.document.dateDue || this.document.dateValidTill) {
      dateDue = moment(this.document.dateDue || this.document.dateValidTill).format('DD.MM.YYYY');
    }

    dateDue = dateDue.replace(/\s/g, '');

    let totalDueCent = new Decimal(this.document.totalDue || 100)
      .mul(100)
      .toDP(0, Decimal.ROUND_FLOOR)
      .toString();

    totalDueCent = totalDueCent.padStart(11, '0');

    const issuerIBAN = (this.document._documentIssuer.IBAN ? this.document._documentIssuer.IBAN : '').trim().substr(0, 34);
    const referenceModel = 'SI00';
    const reference = (this.document.reference || this.document.number || '').trim().substr(0, 22);

    const issuerName = this.document._documentIssuer.name.trim().substr(0, 33);
    const issuerAddress = (this.document._documentIssuer.address ? this.document._documentIssuer.address : '').trim().substr(0, 33);

    let issuerCity = '';
    issuerCity += this.document._documentIssuer.ZIP ? this.document._documentIssuer.ZIP : '';
    issuerCity += ' ' + (this.document._documentIssuer.city ? this.document._documentIssuer.city : '');
    issuerCity = issuerCity.trim().substr(0, 33);

    let qr = 'UPNQR\n'
      + '\n'
      + '\n'
      + '\n'
      + '\n'
      + `${clientName}\n`
      + `${clientAddress}\n`
      + `${clientCity}\n`
      + `${totalDueCent}\n`
      + '\n'
      + '\n'
      + `${purposeCode}\n`
      + `${purpose}\n`
      + `${dateDue}\n`
      + `${issuerIBAN.replace(/\s/g, '')}\n`
      + `${referenceModel}${reference.replace(/\s/g, '')}\n`
      + `${issuerName}\n`
      + `${issuerAddress}\n`
      + `${issuerCity}\n`;

    qr += `${String(qr.length).padStart(3, '0')}\n`;

    this.qr = qr;
  }

  onToggle() {
    this.show = !this.show;
  }

  toUpperCaseFirst(s: string): string {
    return s.slice(0, 1).toUpperCase() + s.slice(1);
  }
}
